module.exports = "/_next/static/images/appearance_in_telephone-9601f1b41752768692bff9130b2cf0bd.jpg";